export enum SIZE {
  TABLET = '600px',
  TABLET_LANDSCAPE = '768px',
  TABLET_BREAK = '888px',
  DESKTOP = '992px',
  LARGE_DESKTOP = '1200px',
  MOBILE_LANDSCAPE = '480px',
}
